export default "__VITE_ASSET__BrFcpKnk__"